import { render, staticRenderFns } from "./Breakdown.vue?vue&type=template&id=d01f397e&scoped=true"
import script from "./Breakdown.vue?vue&type=script&lang=js"
export * from "./Breakdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d01f397e",
  null
  
)

export default component.exports